/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const verifyMfaTokenPostRequestSchema = z.object({
  user_code: z.string(),
});
